import { DocumentLink } from 'components/common-form/sidePanel/docToolbar/regulatory/design-system/DocumentLink';
import { ErrorContent } from 'components/common-form/sidePanel/docToolbar/regulatory/design-system/ErrorContent';
import { LanguageLink } from 'components/common-form/sidePanel/docToolbar/regulatory/design-system/LanguageLink';
import { DocumentItem } from 'epic/common-form/Documentation';
import { useTranslation } from 'hooks/useTranslation';
import type { BlotterAnalyticCategory } from 'models/analytics';
import type { IBlotterItem } from 'models/IBlotterItem';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

import { GenerationFailedError, useTermsheetDownload } from './hooks';

type Props = {
  items: DocumentItem[];
  blotterItem: IBlotterItem;
  analyticsCategory: BlotterAnalyticCategory | undefined;
};

export function TermSheetDocuments({ items, blotterItem, analyticsCategory }: Props) {
  const label = useTranslation('blotterPanel.TermsheetDownload');
  const { onTermsheetDownload, isTermsheetDownloading, error } = useTermsheetDownload(blotterItem);
  const hasError = error !== undefined;

  return (
    <DocumentLink label={label}>
      {items.map((doc, index) => {
        if (isTermsheetDownloading || doc.status === 'Pending') {
          return <LanguageLink key={index} langCode={doc.language} status="pending" />;
        }
        if (hasError || doc.status === 'Generation failed') {
          return (
            <LanguageLink key={index} langCode={doc.language} status="error" severity="warning" onShowError={null}>
              <ErrorContent error={error ?? GenerationFailedError} severity="warning" />
            </LanguageLink>
          );
        }
        return (
          <LanguageLink
            key={index}
            langCode={doc.language}
            status="success"
            onDownload={() => {
              if (analyticsCategory !== undefined) {
                logAnalytics.trackEvent(analyticsCategory, 'Download termsheet', doc.language);
              }
              onTermsheetDownload(doc);
            }}
          />
        );
      })}
    </DocumentLink>
  );
}
